import { render, staticRenderFns } from "./ModalAdminGameSettings.vue?vue&type=template&id=49795be7&scoped=true"
import script from "./ModalAdminGameSettings.vue?vue&type=script&lang=js"
export * from "./ModalAdminGameSettings.vue?vue&type=script&lang=js"
import style0 from "./ModalAdminGameSettings.vue?vue&type=style&index=0&id=49795be7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49795be7",
  null
  
)

export default component.exports